<template>
    <div class="mt48 pl16" >
        <div class="contract-body mt16">
            <h1 class="text-center mb10 mt0">ДОГОВОР <br>{{contractData.type}}</h1>
            <div class="df df--space-between mb20 mt48">
                <span><b>{{contractData.city}}</b></span>
                <span>«____»_____________20___г</span>
            </div>
            <div class="mt48" v-html="contractData.text"></div>
            <div :key="'section'+section.number" class="contract-sections" v-for="section in contractData.sections">
                <h2 class="text-center mt48 mb20 df df--center">{{section.number}}. {{section.title}}</h2>
                <div :key="'section'+itemIndex" v-for="(item,itemIndex) in section.items">
                    <ol v-if="item.type === 'ol'">
                        <li :key="'olItem'+indexOL" v-for="(olItem,indexOL) in item.items">
							<span class="number">{{section.number}}.{{+indexOL + 1}}</span>
							<div class="flex">
	                            <span v-html="olItem.text"></span>
								<ul v-if="olItem.child[0]">
									<li :key="'ulItem'+indexUl" v-for="(ulItem,indexUl) in olItem.child[0].items" v-html="ulItem.text"></li>
								</ul>
							</div>
                        </li>
                    </ol>
                </div>
            </div>

        </div>
        <h2 class="text-center mt48 text-size-ml" v-if="contractData.sections">{{ contractData.sections.length + 1 }}. РЕКВИЗИТЫ И ПОДПИСИ СТОРОН</h2>
        <div class="df df--space-between df--align-start signatures mt20">
            <div class="sign">
                <div class="df df--space-between mb8">
                    <h2 class="text-size-16 mt0 mb0 df">ЗАКАЗЧИК</h2>
                </div>
                <p v-html="contractData.customer"></p>
            </div>
            <div class="sign">
                <div  class="df df--space-between mb8">
                    <h2 class="text-size-16 mt0 mb0">ИСПОЛНИТЕЛЬ</h2>
                </div>
                <p v-html="contractData.executor"></p>
            </div>
        </div>
        <history v-if="contractData.id" :contractDetail="contractData"></history>
    </div>
</template>

<script>
import InputStyled from '@/components/forms/InputStyled.vue';
import EditableItem from '@/components/contract/EditableItem.vue';
import Tooltip from '@/components/Tooltip.vue';
import Popup from '@/components/modal/Popup.vue';
import {mapState} from "vuex";
import History from '@/components/contract/History';

export default {
    name: "ContractDetail",
    components: {
        InputStyled,
        EditableItem,
        Popup,
        Tooltip,
        History
    },
    props: {
        contractData: {}
    },
    data(){
        return {

        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
        }),
    },
    mounted() {
    },
    methods: {

    }
}
</script>

<style>
</style>
